(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["slideshow-with-filter"] && !window.DesignMode) return;
  try {
    
  $('.filter-category').change(function() {
    var url = $(this).val();
    if (url) {
      window.location = url;
    }
    return false;
  });

  $('.filter-tag').change(function() {
    var url = $(this).val();
    if (url) {
      console.log(url);
      window.location = url;
    }
    return false;
  });

  } catch(e) { console.error(e); }
})();

})();
